import type { ReactNode } from 'react';

/** The large welcome band on the agent-creation pages: one clear promise and the main actions. */
export const CreateHero = ({ title, body, children }: { title: string; body: string; children?: ReactNode }) => (
  <div className="create-hero">
    <div className="create-hero-text">
      <h1>{title}</h1>
      <p>{body}</p>
    </div>
    {children && <div className="create-hero-actions">{children}</div>}
  </div>
);
